export { default } from '../../src/pages/Offer'
